<template>
  <a-card type="inner" size="small">
    <a-skeleton :loading="preload" active>
        <a-form :form="form" :layout="formLayout" @submit="handleSubmit">
            <a-divider dashed orientation="left">Informasi Tim Project</a-divider>

            <a-form-item
                :label-col="{ span: layout.label }"
                :wrapper-col="{ span: layout.wrapper }"
                label="Nama"
            >
                <a-input
                    placeholder="Nama"
                    :value="recordData.name"
                    readOnly
                >
                    <a-icon
                        slot="prefix"
                        type="user"
                        style="color: rgba(0, 0, 0, 0.25)"
                    />
                </a-input>
            </a-form-item>
            
            <a-form-item
                :label-col="{ span: layout.label }"
                :wrapper-col="{ span: layout.wrapper }"
                label="Role Klasikal"
            >
                <a-select
                    v-decorator="[
                        'classical_role',
                        { initialValue: recordData.members[0].roles.classical }
                    ]"
                >
                    <a-select-option
                        key="project-owner"
                        value="project-owner"
                    >
                        Project Owner
                    </a-select-option>
                    <a-select-option
                        key="project-manager"
                        value="project-manager"
                    >
                        Project Manager
                    </a-select-option>
                    <a-select-option
                        key="project-owner-client"
                        value="project-owner-client"
                    >
                        Project Owner Client
                    </a-select-option>
                    <a-select-option
                        key="project-manager-client"
                        value="project-manager-client"
                    >
                        Project Manager Client
                    </a-select-option>
                    <a-select-option
                        key="inspirator"
                        value="inspirator"
                    >
                        Inspirator
                    </a-select-option>
                    <a-select-option
                        key="project-sponsor"
                        value="project-sponsor"
                    >
                        Project Sponsor
                    </a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item
                :label-col="{ span: layout.label }"
                :wrapper-col="{ span: layout.wrapper }"
                label="Role OJT"
            >
                <a-select
                    v-decorator="[
                        'ojt_role',
                        { initialValue: recordData.members[0].roles.evaluation }
                    ]"
                >
                    <a-select-option
                        key="advisor"
                        value="advisor"
                    >
                        Pembimbing
                    </a-select-option>
                    <a-select-option
                        key="evaluator"
                        value="evaluator"
                    >
                        Evaluator
                    </a-select-option>
                    <a-select-option
                        key="mentor"
                        value="mentor"
                    >
                        Mentor
                    </a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item
                :label-col="{ span: layout.label }"
                :wrapper-col="{ span: layout.wrapper }"
                label="Cabang"
            >
                <a-select
                    v-decorator="[
                        'branch_id',
                        { initialValue: recordData.members[0].branch != null ? recordData.members[0].branch.hash : null}
                    ]"
                >
                    <a-select-option
                        v-for="d in branches"
                        :key="d.hash"
                        :value="d.hash"
                    >
                        {{ d.name }}
                    </a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item>
                <a-row type="flex" justify="center" align="top">
                    <a-col>
                        <a-space>
                            <a-button
                                type="primary"
                                html-type="submit"
                                :loading="processing"
                                :disabled="processing"
                                >Submit</a-button>
                            <a-button
                                @click="handleClose"
                                :loading="processing"
                                :disabled="processing"
                                >Tutup</a-button>
                        </a-space>
                    </a-col>
                </a-row>
            </a-form-item>
        </a-form>
    </a-skeleton>
  </a-card>
</template>

<script>
export default {
  props: {
        layout: {
            type: Object,
            default: function() {
                return {
                    label: 6,
                    wrapper: 16
                };
            }
        },
        recordData: {
            type: Object,
            default: ""
        },
    },
    created() {
        this.fetchBranches()
        if (this.editing) {
            //this.preload = true;
           // this.getItem();
           console.log(this.recordData)
        }
    },
    computed: {
        editing() {
            return this.recordData !== "";
        },
        activeBank() {
            return this.$laravel.bank
        },
    },
    data() {
        return {
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            branches: [],
            item: {}
        };
    },
    methods: {
        getItem() {
            this.$http
                .get(
                    this.routeUri("api.wom.show", {
                        wom: this.wom
                    })
                )
                .then(res => (this.item = res.data))
                .finally(() => (this.preload = false));
        },
        fetchBranches() {
            this.preload = true;
            let params = {
                bank: this.activeBank.hash
            }

            this.$http
                .get(
                    this.routeUri("api.branches") + '?' + this.$qs.stringify(params))
                .then(res => (this.branches = res.data.branches.data))
                .finally(() => (this.preload = false));
        },
        handleSubmit(e) {
            e.preventDefault(e);

            this.form.validateFields((err, formData) => {
                if (!err) {
                    this.processing = true;

                    let promise;

                    if(formData.branch_id == null){
                        delete formData["branch_id"]
                    }

                    formData.roles = {}

                    formData.roles.classical = formData.classical_role

                    formData.roles.performance = formData.ojt_role
                    formData.roles.paper = formData.ojt_role
                    formData.roles.project = formData.ojt_role
                    formData.roles.evaluation = formData.ojt_role

                    promise = this.$http.put(
                        this.routeUri('api.training-members.update', {member: this.recordData.members[0].member_id}),
                        formData
                    );

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false));
                }
            });
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 2000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false);
        },
    },
    watch: {
        item: function(value) {
            // this.form.getFieldDecorator("title", { initialValue: value.title });
        }
    }
}
</script>